<template>
	<div id='statisticalTable'>
		<el-dialog
			:title='title'
			:visible.sync="isShow"
			:close-on-click-modal="false"
			class="default-dialog"
			width='1000px'
		>
			<div>
				<el-form inline label-position="left">
					<el-form-item label='明细账：'>
						<accounting-period @defaultTime='defaultTime' :isDaterange='false'></accounting-period>
					</el-form-item>
					<el-form-item >
						<el-button size='mini' class='minButton elButton_sr' @click='getTableList'>
							搜索
						</el-button>
					</el-form-item>
				</el-form>
				<public-table :table='tableData'></public-table>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	import publicTable from '@/components/publicTable'
	import {currencys} from '@/assets/utils/currencyFormat'
	import accountingPeriod from '@/components/dialog/accountingPeriod'
	export default{
		components: {
			accountingPeriod,
			publicTable
		},
		props: {
			showVisible: Boolean,
			params: {
				type: Object,
				default(){
					return {
						subjectId: '',      // 科目ID
						auxiliaryId: '',     // 辅助核算ID
						name: '',         // 公司名字
					}
				}
			}
		},
		data() {
			return {
				title: '',
				form: {
					yearPeriods: '',
					auxiliaryId: '',
					subjectId: '',
				},
				tableData: {
					isNotSuspensionShow: true,  // 不显示悬浮效果
					border: true,				// 是否带有纵向边框
					stripe: true,				// 是否带有斑马纹
					loading: false,				// 是否显示加载动画
					hasSelect: false,			// 是否显示多选
					hasOperation: false,		// 是否有操作功能
					hasContextmenu: false,		// 是否有右键功能
					hasShowSummary: true,		// 是否显示合计行
					hasShowPagination: false,	// 是否显示分页
					config: [{
						label: '日期',
						value: 'date',
						show: 'normal'
					},{
						label: '凭证号',
						value: 'certificateWord',
						show: 'normal'
					},{
						label: '摘要',
						value: 'summary',
						show: 'normal',
					},{
						label: '借方',
						value: 'debitMoney',
						formatter: this.formatter,
						show: 'normal',
					},{
						label: '贷方',
						value: 'creditorMoney',
						formatter: this.formatter,
						show: 'normal',
					},{
						label: '方向',
						value: 'creditDirection',
						show: 'normal',
					},{
						label: '余额',
						value: 'remainingSum',
						formatter: this.formatter,
						show: 'normal',
					}],
					data: [],
					page: {
						pageNo: 1,
						pageSize: 20,
						count: 10
					},
					center: {
						textAlign: 'center',
						padding: '6px 0'
					},
					getSummaries: this.getSummaries,			// 自定义合计方法
				},
			}
		},
		created() {

		},
		mounted() {

		},
		computed:　{
			// 显示弹窗
			isShow: {
				get () {
					return this.showVisible;
				},
				set (val) {
					this.$emit('update:showVisible', val);
				}
			},
		},
		methods: {
			// 自定义合计
			getSummaries (param) {
				const { columns, data } = param;
				const sums = [];

				columns.forEach((column, index) => {
					if (index === 0) {
						sums[index] = '合计';
						return;
					}
					if(index === 1 || index === 2 || index === 5) {
						return;
					}
					const values = data.map(item => {
						return Number(item[column.property])
					});

					if (!values.every(value => {isNaN(value)})) {
						sums[index] = values.reduce((prev, curr) => {
							const value = Number(curr);
							if(!isNaN(value)) {
								prev = Number(prev)
								if(!(parseFloat(prev)+parseFloat(curr))) {
									return '';
								}else {
									return (parseFloat(prev)+parseFloat(curr)).toFixed(2);
								}
							} else {
								return parseFloat(prev).toFixed(2);
							}
						}, 0);
					} else {
						sums[index] = '';
					}
				});
				if(sums) {
					return sums;
				}else {
					return '';
				}
			},
			// 表格格式化
			formatter(row, column, cellValue, index) {
				if(!row[column.property]) {
					return "";
				}else {
					return currencys(row[column.property]);
				}
			},
			// 接收会计期间数据
			defaultTime(data) {
				this.form = Object.assign(this.form,{
					yearPeriods: this.$util.formatDate.format(data.yearPeriodsStart , 'yyyyMM'),
				})
				
			},
			getTableList() {
				this.tableData.loading = true;
				try {
					this.$http.post('title/getDetailedBySubjectIdAndAuxiliaryId',this.form).then(res=>{
						this.tableData.loading = false;
						if(res && res.data.code == 1) {
							this.tableData.data = res.data.data;
							if(this.tableData.data.length) {
								this.tableData.data.forEach(i=>{
									i.date = this.$util.formatDate.format(i.date , 'yyyy-MM-dd');
								})
							}
							

						}
					})
				}catch(e) {
					this.tableData.loading = false;

				}
			},
		},
		watch: {
			isShow(val) {
				this.form = Object.assign(this.form , {
					subjectId: this.params.subjectId,
					auxiliaryId: this.params.auxiliaryId,
				})
				this.title = this.params.name;
				if(val) {
					this.getTableList();
				}
			}
		}
	}
</script>
<style lang='less' scoped>
	
</style>


// WEBPACK FOOTER //
// src/components/dialog/statisticalTable.vue